import React, { useState, useEffect, useRef } from 'react';
import GridConfig from './Grid/GridConfig';
import { withStyles } from '@material-ui/core';
import { compose } from 'recompose';
import { withSnackbar } from 'notistack';
import ReceiversDataGrid from './Grid/DataGrid';
import localStyles from './Grid/style';
import { withUserProfile } from '../../../../../../userProfile/userProfileContext';
import { getDataWithQueryString } from '../../../../../../api/componentAPIs';
import AddEditReceiver from './Form';
import DeleteReceiver from './DeleteReceiver';

const Receivers = ({ classes, enqueueSnackbar, userData, customerCode }) => {
  const [receiverList, setReceiverList] = useState(null);
  const [receiverDetails, setReceiverDetails] = useState(null);
  const [selectedReceivers, setSelectedReceivers] = useState([]);
  const [showReceiverForm, setShowReceiverForm] = useState(false);
  const [selectedReceiverData, setSelectedReceiverData] = useState(null);

  const gridConfig = useRef(new GridConfig());

  useEffect(() => {
    fetchReceivers();
  }, []);

  const fetchReceivers = () => {
    getDataWithQueryString(
      'GetCustomerReceivers',
      `terminalCode=${userData?.userProfile.terminal.code}&customerCode=${customerCode}`
    ).then((response) => {
      if (response && response.status >= 200 && response.status < 400) {
        setReceiverList(response.data);
      } else {
        handleReceiversFetchError();
      }
    });
  };

  const getReceiverById = (receiverId) => {
    return receiverList?.find((receiver) => receiver.receiverId === receiverId) || null;
  };

  const handleReceiversFetchError = () => {
    setReceiverList([]);
    enqueueSnackbar('Failed to fetch receivers', {
      variant: 'error'
    });
  };

  const openAddEditReceiverPanel = (receiverId) => {
    setShowReceiverForm(true);
    setReceiverDetails(getReceiverById(receiverId));
  };

  const closeAddEditReceiverPanel = (receiverId = null) => {
    if (receiverId) {
      fetchReceivers();
      setSelectedReceivers([receiverId]);
    }
    setShowReceiverForm(false);
    setReceiverDetails(null);
  };

  const openDeleteReceiver = (receiverId) => {
    setSelectedReceiverData(getReceiverById(receiverId));
  };

  const onCancelReceiverDeletion = (receiverId = null) => {
    setSelectedReceiverData(null);
    setSelectedReceivers([]);
    if (receiverId) {
      fetchReceivers();
    }
  };

  return (
    <>
      <ReceiversDataGrid
        gridData={receiverList}
        selectedReceivers={selectedReceivers}
        gridConfig={gridConfig.current}
        classes={classes}
        openAddEditReceiverPanel={openAddEditReceiverPanel}
        setSelectedReceiverData={setSelectedReceivers}
        openDeleteReceiver={openDeleteReceiver}
        showReceiverForm={showReceiverForm}
        selectedReceiverData={selectedReceiverData}
      />
      {showReceiverForm && (
        <AddEditReceiver
          open={showReceiverForm}
          onClose={closeAddEditReceiverPanel}
          receiverDetails={receiverDetails}
          drawerClasses={{
            paper: classes.paperAnchor
          }}
          variant="persistent"
          enqueueSnackbar={enqueueSnackbar}
          terminalCode={userData.userProfile.terminal.code}
          customerCode={customerCode}
        />
      )}
      {selectedReceiverData && (
        <DeleteReceiver
          onCancel={onCancelReceiverDeletion}
          selectedReceiverData={selectedReceiverData}
          enqueueSnackbar={enqueueSnackbar}
          terminalCode={userData.userProfile.terminal.code}
        />
      )}
    </>
  );
};

export default compose(withStyles(localStyles), withSnackbar, withUserProfile)(Receivers);
